import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { ResetPasswordPayload, SuccessResponse } from 'services/requests';
import { useNavigate } from 'hooks/routes';
import { Messages } from 'constants/messages';
import { MutationKeys } from 'constants/mutationKeys';
import { showSuccessToast } from 'components/Toast';

export const useResetPassword = () => {
  const mutate = async (payload: ResetPasswordPayload) => {
    const { data } = await api.resetPassword(payload);

    return data;
  };

  const mutationKey = MutationKeys.resetPassword;
  const { toLogin } = useNavigate();

  return useMutation<SuccessResponse, AxiosError<ApiError>, ResetPasswordPayload>(
    mutationKey,
    mutate,
    {
      onSuccess: () => {
        toLogin();
        showSuccessToast(Messages.passwordHasBeenChanged);
      },
    },
  );
};
